import { apiService } from './api';
import { LoginCredentials, AuthResponse, ApiResponse } from '../types';

export const authService = {
  async loginAdmin(credentials: LoginCredentials): Promise<ApiResponse<AuthResponse>> {
    return apiService.post<AuthResponse>('/api/auth/login/admin', credentials);
  },

  async loginClient(credentials: LoginCredentials): Promise<ApiResponse<AuthResponse>> {
    return apiService.post<AuthResponse>('/api/auth/login/client', credentials);
  },

  async loginModerator(credentials: LoginCredentials): Promise<ApiResponse<AuthResponse>> {
    return apiService.post<AuthResponse>('/api/auth/login/moderator', credentials);
  },

  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },

  getToken(): string | null {
    return localStorage.getItem('access_token');
  },

  getUser(): any {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  setAuthData(token: string, user: any): void {
    try {
      localStorage.setItem('access_token', token);
      localStorage.setItem('user', JSON.stringify(user));
      // Verify it was stored
      const storedToken = localStorage.getItem('access_token');
      if (!storedToken || storedToken !== token) {
        console.error('Failed to store token in localStorage');
      }
    } catch (error) {
      console.error('Error storing auth data:', error);
      throw error;
    }
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },
};

